<template>
    <div class="list media-list no-hairlines no-hairlines-between">
        <ul>
            <slot></slot>
        </ul>
    </div>
</template>

<script>
  export default {
    name: ''
  }
</script>

<style lang="scss" scoped type="text/css">
    .list {
        margin: 0;
    }

    .list ul {
        background: #efeff4;
    }
</style>